import { render } from "./OtherProfileBody.vue?vue&type=template&id=62e77e79&scoped=true"
import script from "./OtherProfileBody.vue?vue&type=script&lang=js"
export * from "./OtherProfileBody.vue?vue&type=script&lang=js"

import "./OtherProfileBody.vue?vue&type=style&index=0&id=62e77e79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e77e79"]])

export default __exports__